"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NewUsersPageHighchartsOptionsProvider = void 0;
const React = __importStar(require("react"));
const HighchartsOptionsProvider_1 = require("src/hello_assets/src/components/ui/common/content/highcharts/HighchartsOptionsProvider");
const ProjectHighchartsOptionsProvider_1 = require("src/hello_assets/src/components/ui/loggedin/content/common/highcharts/ProjectHighchartsOptionsProvider");
const NewUsersPageDataProvider_1 = require("src/hello_assets/src/components/ui/loggedin/content/project/withData/features/newUsers/NewUsersPageDataProvider");
const lodash_1 = __importDefault(require("lodash"));
exports.NewUsersPageHighchartsOptionsProvider = React.memo((props) => {
    const pageDataContext = (0, NewUsersPageDataProvider_1.useNewUsersPageDataContext)();
    const jsonModel = pageDataContext.stateFns.getURLJSONModel();
    const lineType = jsonModel.getLineTypeJSONModel().getLineType();
    const cumulativeGrowthPercent = jsonModel.getChartSettingsJSONModel().getCumulativeGrowthPercent();
    return React.createElement(React.Fragment, null,
        React.createElement(HighchartsOptionsProvider_1.HighchartsOptionsProvider, { error: pageDataContext.state.error, data: pageDataContext.state.data, parameters: {
                lineType: lineType,
                cumulativeGrowthPercent: cumulativeGrowthPercent
            }, highchartsOptionsProviderFn: ProjectHighchartsOptionsProvider_1.ProjectHighchartsOptionsProvider.getNewUsersOptions }, props.children));
}, lodash_1.default.isEqual);
